<script lang="ts">
	import bib from '$assets/errors/bib-error.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import * as m from '$paraglide/messages';
	import { SUPPORTED_LOCALES, type SupportedLocale } from '@viamichelin/business';
	import ModalDialog from '../modals/ModalDialog.svelte';
	import { langData } from './constants';

	interface Props {
		open?: boolean;
		currentLocale: SupportedLocale;
	}

	let { open = $bindable(false), currentLocale }: Props = $props();

	function close() {
		open = false;
	}
</script>

<ModalDialog bind:open centered contentDialogClasses="!relative p-2">
	{#snippet closeButtonSlot()}
		<Button
			color="white"
			icon="close"
			text={$isMobile ? m.modal__close() : undefined}
			class={$isMobile ? '' : 'absolute top-8 right-8 z-infront'}
			onclick={close}
		/>
	{/snippet}
	<div class="flex flex-col md:flex-row bg-neutral-weakest rd-2 md:rd-4 max-w-196 overflow-hidden">
		<div class="flex flex-col p-8 gap-8">
			<div class="text-title">{m.modal__locale_switch_title()}</div>
			<div class="lang-container flex flex-col gap-1 items-start">
				<!-- eslint-disable-next-line svelte/require-each-key -->
				{#each SUPPORTED_LOCALES as locale}
					<Link
						button={currentLocale === locale ? 'filled' : 'ghost'}
						color={currentLocale === locale ? 'light' : undefined}
						disabled={currentLocale === locale}
						label={langData[locale].text}
						icon={langData[locale].icon}
						href={langData[locale].url}
						lang={locale}
						hreflang={locale}
					/>
				{/each}
			</div>
		</div>
		<div class="bg-primary w-full h-43 md:h-auto md:min-h-86 md:w-64 relative">
			<img src={bib} class="absolute bib bottom--12 md:bottom-0 w-55" alt="" />
		</div>
	</div>
</ModalDialog>

<style>
	.bib {
		left: 50%;
		transform: translateX(-50%);
	}

	@media screen and (min-width: 960px) {
		.bib {
			right: 72px;
			left: unset;
			transform: unset;
		}

		.lang-container {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			justify-items: start;
		}
	}
</style>
